import { useCallback, useState } from "react";

let nextFeedbackId = 0;

const buildFeedbackId = () => {
  nextFeedbackId += 1;
  return `guest-feedback-${nextFeedbackId}`;
};

const useGuestFeedback = () => {
  const [feedbackItems, setFeedbackItems] = useState([]);

  const pushFeedback = useCallback((item) => {
    const variant = item.variant || "info";

    setFeedbackItems((prev) => [
      ...prev,
      {
        id: buildFeedbackId(),
        autohide: variant === "success" || variant === "info",
        delay: 3000,
        ...item,
      },
    ]);
  }, []);

  const dismissFeedback = useCallback((id) => {
    setFeedbackItems((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const clearFeedback = useCallback(() => {
    setFeedbackItems([]);
  }, []);

  return {
    feedbackItems,
    pushFeedback,
    dismissFeedback,
    clearFeedback,
  };
};

export default useGuestFeedback;
